module.exports = __webpack_public_path__ + "img/arrow-mini.cf82f949.svg";